module.exports = __webpack_public_path__ + "img/quick_easy_enrollment.c2a2aacc.jpg";